import React, { useEffect, useState } from 'react'
import Slides from '../slides/Slides';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuthContext } from '../../context/authContext';
import Footer from '../footer/Footer';
import { WebService } from '../../services/webService';

const Cuestionario = ({M}) => {
   const { id } = useParams();
   const { nominaID, identity, nominaNombre, nominaDNI } = useAuthContext();
   const [preguntas,setPreguntas] = useState();
   
   const getCuestionario = async () => {
      try {
         const data = await WebService.getCuestionario(id);
         setPreguntas(data || []);
      } catch (error) {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se pudo cargar el cuestionario",
            confirmButtonColor: "#147B9C",
         });
      }
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      formData.append("nomina_id", nominaID);
      formData.append("email", identity);
      formData.append("nomina_nombre", nominaNombre);
      formData.append("nomina_dni", nominaDNI);
      axios
      .post(`${process.env.REACT_APP_API_URL}/web/resultado/${id}`,formData)
      .then((payload) => {
         Swal.fire({
            icon: payload.data.icon,
            title: payload.data.title,
            text: payload.data.message,
            showConfirmButton: true,
            confirmButtonText: "Ok",
         }).then((response) => {});
      }).catch((error) => {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: error.response.data.error,
            showConfirmButton: true,
            confirmButtonText: "Ok",
         });
      });
   }
   
   useEffect(() => {
      getCuestionario();
   }, []);
   return (
      <>
         <Slides M={M} tipoSlides={"cuestionario"} />
         <div className="container animated fadeIn">
            <div className="section">
               <div className="row">
                  <div className="col s12 m12 center-align">
                     <Link className="btn waves-effect waves-light light-blue accent-3" type="button" to={"/cursos"}> Volver Atras
                     </Link>
                  </div>
               </div>
               <div className="row">
                  <div className="col s12 m12 l12 x12 ">
                     <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="card  darken-1">
                           <div className="card-content">
                              {
                                 preguntas?.map((p,index) => {
                                    return(
                                       <>
                                          <span className="card-title"><strong>{p.pregunta_pregunta}</strong></span>
                                          {
                                             p.pregunta_imagen !== null &&
                                             <div className="center">
                                                <img lass="materialboxed" width="300" src={`/app.latitud/img/cursos/${p.pregunta_imagen}`}/>
                                             </div>
                                          }
                                          <ul>
                                             {
                                                p.respuestas?.map((r,index) => {
                                                   return(
                                                      <>
                                                         {r.respuesta_check_radio === "1" ?
                                                            <li><label className="blue-text"><input type="checkbox" value={r.respuesta_id} name={`respuesta_check[${r.respuesta_id}]`}/><span><i>{r.respuesta_respuesta}</i></span></label></li>
                                                            :
                                                            <li><label className="blue-text"><input type="radio" value={r.respuesta_id} name={`respuesta_radio[${p.pregunta_id}]`}/><span><i>{r.respuesta_respuesta}</i></span></label></li>
                                                         }
                                                      </>
                                                   )

                                                })   
                                             }
                                          </ul>
                                       </>
                                    )
                                 })
                              }
                              <div className="row">
                                 <div className="col s12 m12 center-align">
                                    <button className="btn waves-effect waves-light light-blue accent-3" type="submit" name="action">Finalizar
                                       <i className="material-icons right">send</i>
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}

export default Cuestionario